import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './core/layouts/auth-layout/auth-layout.component';
import { DashboadLayoutComponent } from './core/layouts/dashboad-layout/dashboad-layout.component';
import { authGuard } from './core/guard/auth.guard';
import { processGuard } from './core/guard/process.guard';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptor/auth.interceptor';

export const routes: Routes = [
  // ---------- Public (auth layout) ----------
  {
    path: '',
    providers: [provideHttpClient(withInterceptors([authInterceptor]))],
    component: AuthLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      {
        path: 'login',
        loadComponent: () =>
          import('./core/pages/sign-in/sign-in.component').then(m => m.SignInComponent),
      },
      // {
      //   path: 'forgot-password',
      //   loadComponent: () =>
      //     import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
      // },
      {
        path: 'contact-us',
        loadComponent: () =>
          import('./core/pages/contact-us/contact-us.component').then(c => c.ContactUsComponent),
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./core/pages/privacy/privacy.component').then(c => c.PrivacyComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./core/pages/policy/policy.component').then(c => c.PolicyComponent),
      },
    ],
  },
  {
    path: '',
    component: DashboadLayoutComponent,
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./core/pages/home/home.component').then(c => c.HomeComponent),
        canActivate: [authGuard],
      },
      {
        path: 'shop',
        loadComponent: () =>
          import('./core/pages/products/products.component').then(m => m.ProductsComponent),
        canActivate: [authGuard],
      },
      {
        path: 'product-overview',
        loadComponent: () =>
          import('./core/pages/product-overview/product-overview.component').then(m => m.ProductOverviewComponent),
        canActivate: [authGuard],
      },

      {
        path: 'orders',
        loadComponent: () =>
          import('./core/pages/my-orders/my-orders.component').then(m => m.MyOrdersComponent),
        canActivate: [authGuard],
      },

      {
        path: 'cart',
        loadComponent: () =>
          import('./core/pages/cart/cart.component').then(c => c.CartComponent)
      },
      {
        path: 'products/category/:categoryId',
        pathMatch: 'full',
        redirectTo: 'shop/category/:categoryId',
      },
      {
        path: 'products/subcategory/:subCategoryId',
        pathMatch: 'full',
        redirectTo: 'shop/subcategory/:subCategoryId',
      },
    ],
  },
  {
    path: 'successfull',
    loadComponent: () =>
      import('./core/pages/successfull/successfull.component').then(c => c.SuccessfullComponent)
  },
  {
    path: 'canceled',
    loadComponent: () =>
      import('./core/pages/cancelled/cancelled.component').then(c => c.CancelledComponent)
  },
  {
    path: 'order-approval',
    providers: [provideHttpClient(withInterceptors([authInterceptor]))],
    loadComponent: () =>
      import('./core/pages/order-email-approval-component/order-email-approval-component')
        .then(m => m.OrderEmailApprovalComponent),
    canActivate: [authGuard],
  },

// Keep the wildcard route last
{ path: '**', redirectTo: '/login', pathMatch: 'full' },

];